import { FieldErrors } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { SelectOptions } from "~/types/Select";
import { useGetLocationData } from "~/hooks/locationData";
import { OpenModalActions } from "~/types/OpenModalActions";

type GetFieldsParams = {
  errors: any;
  positions: SelectOptions[];
  intersectionObserver: any;
  searchText: any;
};
export const getFields = ({
  errors,
  positions,
  intersectionObserver,
  searchText,
}: GetFieldsParams) => {
  const { openModal } = useGetLocationData();

  const isView = openModal === OpenModalActions.View;

  const { t } = useTranslation();

  return [
    {
      isInput: true,
      name: "name",
      label: t("information_system.name"),
      error: errors["name"]?.message || "",
      disabled: Boolean(isView),
    },
    {
      isMultiSelect: true,
      name: "positions",
      label: t("information_system.Positions"),
      options: positions,
      error: (errors as FieldErrors)["positions"]?.message || "",
      scrollBottom: intersectionObserver,
      searchText: searchText,
      disabled: Boolean(isView),
    },
  ];
};
